import React from 'react'
import { Grid } from '@mui/material'
import {
  A11yStatementLink,
  B2BPrivacyPolicyLink,
  B2BCookiesPolicyLink,
  B2BTandCLink,
  B2BContactLink
} from './links'
import { useFormFactor } from '../../hooks'
import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(({ palette, spacing, typography }) => ({
  links: {
    paddingLeft: spacing(3),
    paddingRight: spacing(3),
    '& *': {
      color: palette.grey.shade[80],
      fontWeight: typography.fontWeightMedium,
      fontSize: '1rem'
    }
  },
  nav: {
    display: 'flex',
    justifyContent: 'center'
  }
}))

const LinkPanel = () => {
  const classes = useStyles()
  const { isMobile, isSmallTablet } = useFormFactor()
  const isSmall = isMobile || isSmallTablet
  return (
    <nav className={isSmall ? {} : classes.nav}>
      <Grid
        container
        direction={isSmall ? 'column' : 'row'}
        alignItems='center'
        maxWidth={1440}
        justifyContent={isSmall ? 'center' : 'space-around'}
        spacing={isSmall ? 3 : 0}
        className={classes.links}
      >
        <Grid item xs={12} sm='auto'>
          <B2BPrivacyPolicyLink />
        </Grid>
        <Grid item xs={12} sm='auto'>
          <B2BCookiesPolicyLink />
        </Grid>
        <Grid item xs={12} sm='auto'>
          <A11yStatementLink />
        </Grid>
        <Grid item xs={12} sm='auto'>
          <B2BTandCLink />
        </Grid>
        <Grid item xs={12} sm='auto'>
          <B2BContactLink />
        </Grid>
      </Grid>
    </nav>
  )
}

export default LinkPanel
